import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ServerProvider } from './context/serverContext';
import { AuthProvider } from './context/AuthContext';
import { LangProvider } from './context/LangContext';
import { BuyProvider } from './context/BuyContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<ServerProvider>
					<LangProvider>
						<BuyProvider>
							<App />
						</BuyProvider>
					</LangProvider>
				</ServerProvider>
			</AuthProvider>
		</BrowserRouter>
 	</React.StrictMode>
);
